<template>
  <form grid="row wrap" @submit.prevent="generateReport">
    <div column="12">
      <h5
        v-if="reportingUserMessage.length > 0"
        class="lips _text-center">
        {{ reportingUserMessage }}
      </h5>

      <div class="content-wrap _mbs _mts">
        <h2>Generate Enrollment Report</h2>
      </div>
    </div>
    <div column="xs-12 s-6 m-6 l-4">
      <app-select
        :required="true"
        :has-blank-option="false"
        label="Group"
        name="group"
        :options="groupOptions"
        @click.stop.prevent="onGroupClick($event)"
        @keydown.stop.prevent="onGroupClick($event)"
        :value="$v.groupCk.$model"
        :errorMessage="groupCkError"
        :invalid="$v.groupCk.$invalid"
      />
    </div>
    <div column="xs-12 s-6 m-6 l-4">
      <app-select
        :hasBlankOption="false"
        label="Subgroup"
        name="subgroup"
        :options="subGroupOptions"
        @click.stop.prevent="onSubGroupClick($event)"
        @keydown.stop.prevent="onSubGroupClick($event)"
        :value="subGroupCk"
      />
    </div>
    <div column="xs-12 s-6 m-6 l-4">
      <app-select
        :has-blank-option="false"
        label="Status"
        name="memberStatus"
        :options="memberStatusOptions"
        v-model="memberStatus"
      />
    </div>
    <div column="12" class="_mtxs">
      <div class="button-wrap">
        <async-button
          class="--sm"
          type="submit"
          :executing="generatingReport"
          :disabled="!groupCk"
        >
          generate report
        </async-button>
      </div>
    </div>
    <div column="12">
      <hr class="_mbxs _mts">
    </div>
  </form>
</template>
<script>
  import validations from './validations'
  // import reporting from '@mixins/reporting'
  import AppSelect from '@atoms/Select';
  import AsyncButton from '@molecules/AsyncButton';
  import { computed, ref } from '@vue/composition-api';
  import { useGroupSelector } from '@composables/useGroupSelector';
  import { useReporting } from '@composables/useReporting';
  import { useStore } from '@vue3shims';

  export default {
    mixins: [validations],
    components: {
      AppSelect,
      AsyncButton
    },
    setup() {
      const store = useStore();

      const { openGroupSelector, selected } = useGroupSelector();
      const { generatingReport, reportingUserMessage } = useReporting();
      const generateReport = () => {
        store.dispatch('reporting/GET_ENROLLMENT_REPORTS', payload.value)
      }
      const groupCk = computed(() => selected.value.groupCk);
      const groupId = computed(() => selected.value.groupId);
      const groupOptions = computed(() => [{ value: selected.value.groupCk, text: selected.value.groupName }]);
      const isInternalUser = computed(() => store.getters['isInternalUser']);
      const memberStatus = ref('All');
      const memberStatusOptions = [
        { text: 'All', value: 'All' },
        { text: 'Active', value: 'Active' },
        { text: 'Inactive', value: 'Inactive' }
      ];
      const onGroupClick = (e) => {
        if (selected.value.groupCk === '') {
          openPortalContext('group', e);
        }
      }
      const onSubGroupClick = (e) => {
        if (selected.value.subGroupCk === '') {
          openPortalContext('subGroup', e);
        }
      }
      const openPortalContext = (tab, e) => {
        // force a blur or the select dropdown will appear over portal context
        e.target.blur()
        setTimeout(() => openGroupSelector(tab), 50);
      }
      const payload = computed(() => {
        return {
          parentGroupCk: selected.value.parentGroupCk,
          groupCk: selected.value.groupCk,
          subGroupCk: selected.value.subGroupCk,
          filterType: memberStatus.value,
        }
      });
      const subGroupCk = computed(() => selected.value.subGroupCk);
      const subGroupId = computed(() => selected.value.subGroupId);
      const subGroupOptions = computed(() => [{ value: selected.value.subGroupCk, text: selected.value.subGroupName }]);

      return {
        generateReport,
        generatingReport,
        groupCk,
        groupId, 
        groupOptions,
        memberStatus,
        memberStatusOptions,
        onGroupClick,
        onSubGroupClick,
        openPortalContext,
        reportingUserMessage,
        subGroupCk,
        subGroupId,
        subGroupOptions,
      }
    },
  }
</script>
